/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! AI UX Auditor — viewer.
 *  /audit -> UX grade + issues/strengths ; /get?id=<vid> -> one visitor's experience audit.
 *  Talks through the app's GS.api ({ok,status,data}). Deep-linkable via ?id=<vid>.
 */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["ux-auditor"] = "1.0.0"; } catch (e) {}
  if (window.__buxWired) return; window.__buxWired = 1;

  var root = document.querySelector('[data-ux="root"]');
  if (!root) return;
  function q(k) { return root.querySelector('[data-ux="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function num(n) { return (+n || 0).toLocaleString(); }
  function gradeCls(g) { return "g-" + (g || "F"); }
  function ready(fn) {
    var done = false; function go() { if (done) return; done = true; fn(); }
    document.addEventListener("gs:ready", go, { once: true });
    var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30);
    if (window.GS && GS.api && GS.site) go();
  }
  function iso(ms) { return new Date(ms).toISOString().slice(0, 10); }
  var RANGE = { from: iso(Date.now() - 30 * 86400000), to: iso(Date.now()) };
  function _rpT(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function _rpYmd(d){return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2);}
  function _rpToday(){var n=new Date();return new Date(Date.UTC(n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()));}
  function _rpPreset(days){var to=_rpToday(),from=new Date(to.getTime()-(days-1)*86400000);var lbl={7:_rpT("an.last7"),30:_rpT("an.last30"),90:_rpT("an.last90"),365:_rpT("an.last12mo")}[days]||(days+" days");return {from:_rpYmd(from),to:_rpYmd(to),label:lbl,preset:String(days)};}
  var _RPL={label:null,preset:"30"};
  (function(){try{var s=JSON.parse(localStorage.getItem("gs_ux_range")||"null");if(s&&s.preset){var p=_rpPreset(+s.preset);RANGE.from=p.from;RANGE.to=p.to;_RPL.label=p.label;_RPL.preset=p.preset;}else if(s&&s.from&&s.to){RANGE.from=s.from;RANGE.to=s.to;_RPL.label=s.from+" \u2192 "+s.to;_RPL.preset=null;}}catch(e){}if(!_RPL.label){var d=_rpPreset(30);_RPL.label=d.label;}})();
  function _rpInit(){
    function _rpBtnLabel(menu,preset){if(!menu||!preset)return null;var b=menu.querySelector('.rm[data-preset="'+preset+'"]');return b?b.textContent.trim():null;}
    
    if(_RPL&&_RPL.preset){var _rp=_rpPreset(+_RPL.preset);_RPL.label=_rp.label;if(typeof RANGE!=="undefined"&&RANGE){RANGE.label=_rp.label;}}
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label");if(!btn||!menu)return;
    (function(){var _pp=(typeof RANGE!=="undefined"&&RANGE&&RANGE.preset)||(typeof _RPL!=="undefined"&&_RPL&&_RPL.preset);var _bl=_rpBtnLabel(menu,_pp);if(_bl){if(lab)lab.textContent=_bl;if(typeof RANGE!=="undefined"&&RANGE)RANGE.label=_bl;if(typeof _RPL!=="undefined"&&_RPL)_RPL.label=_bl;}})();
    if(lab&&_RPL.label)lab.textContent=_RPL.label;
    function sync(){menu.querySelectorAll(".rm[data-preset]").forEach(function(x){x.classList.toggle("on",x.getAttribute("data-preset")===_RPL.preset);});}
    btn.addEventListener("click",function(e){if(menu.contains(e.target)&&e.target!==btn)return;e.stopPropagation();var open=menu.style.display!=="none";menu.style.display=open?"none":"block";if(!open){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf)cf.value=RANGE.from;if(ct)ct.value=RANGE.to;sync();}});
    document.addEventListener("click",function(e){if(!btn.contains(e.target))menu.style.display="none";});
    function apply(o){ if(o&&o.preset){var _bl2=_rpBtnLabel(menu,o.preset);if(_bl2)o.label=_bl2;}RANGE.from=o.from;RANGE.to=o.to;_RPL.label=o.label;_RPL.preset=o.preset;if(lab)lab.textContent=o.label;try{localStorage.setItem("gs_ux_range",JSON.stringify({from:o.from,to:o.to,preset:o.preset}));}catch(e){}menu.style.display="none";loadAudit();}
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){b.addEventListener("click",function(){apply(_rpPreset(+b.getAttribute("data-preset")));});});
    var ap=menu.querySelector('[data-rp="apply"]');if(ap)ap.addEventListener("click",function(){var ff=menu.querySelector('[data-rp="from"]').value,tt=menu.querySelector('[data-rp="to"]').value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}apply({from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null});});
  }

  /* ---- concrete add/change/move actions per issue + "Inspect on page" (UX Doctor) ----
   * PAGE_FOR maps each issue id to its worst affected page (from the audit's worst-first pages),
   * so Inspect deep-links straight to that page's UX Doctor report. */
  var PAGE_FOR = {}, ISSUE_BY_ID = {}, drawerEl = null, backdropEl = null;
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  var ACTIONS = {
    rage_clicks: [{ v: "add", t: "visible hover, active, and loading states to buttons and links" }, { v: "change", t: "slow or broken click handlers so every click responds" }, { v: "remove", t: "clickable styling from elements that aren\u2019t interactive" }],
    navigation_thrash: [{ v: "add", t: "on-site search and prominent links to the most-wanted pages" }, { v: "change", t: "vague nav labels to plain, specific wording" }, { v: "move", t: "key destinations into the main nav where people look first" }],
    content_friction: [{ v: "move", t: "primary content and CTAs above the fold" }, { v: "change", t: "long hero sections \u2014 shorten them" }, { v: "remove", t: "above-the-fold clutter that delays the key material" }],
    attention_sink: [{ v: "add", t: "one clear focal point and visual hierarchy per page" }, { v: "remove", t: "competing elements and motion that split attention" }, { v: "change", t: "the layout so the eye lands on the primary action first" }],
    missing_affordances: [{ v: "add", t: "buttons, links, or expandable sections where interest peaks" }, { v: "move", t: "the main action to where engaged visitors currently stall" }],
    cognitive_load: [{ v: "remove", t: "unnecessary choices and steps" }, { v: "change", t: "unclear labels so the next action is obvious" }]
  };
  function inspectLink(x) {
    if (!x.id) return "";
    return '<button type="button" class="ux-inspect" data-ux-inspect="' + esc(x.id) + '" title="'+TT('uxa.tip_inspect')+'"><i class="bi bi-crosshair"></i> Inspect on page</button>';
  }
  function siteDomain() {
    var a = (window.GS && GS.sites) || [];
    var s = a.filter(function (x) { return x.public_key === GS.site; })[0] || a[0];
    return (s && s.domain) ? String(s.domain) : "";
  }
  function pageURL(path) {
    var p = path || "/"; if (p.charAt(0) !== "/") p = "/" + p;
    var d = siteDomain(); if (!d) return p;
    return (/^https?:\/\//i.test(d) ? d : "https://" + d).replace(/\/+$/, "") + p;
  }
  function closeInspect() { if (drawerEl) drawerEl.classList.remove("open"); if (backdropEl) backdropEl.classList.remove("open"); }
  function ensureDrawer() {
    if (drawerEl) return;
    var body = document.body || document.documentElement;
    backdropEl = document.createElement("div"); backdropEl.className = "gsux-ocb";
    drawerEl = document.createElement("div"); drawerEl.className = "gsux-oc";
    drawerEl.setAttribute("role", "dialog"); drawerEl.setAttribute("aria-modal", "true"); drawerEl.setAttribute("aria-label", TR('uxaudi.g.inspect_finding'));
    body.appendChild(backdropEl); body.appendChild(drawerEl);
    backdropEl.addEventListener("click", closeInspect);
    document.addEventListener("keydown", function (e) { if (e.key === TR('uxaudi.g.escape')) closeInspect(); });
  }
  function chip(a) { return '<li class="gsux-act"><span class="gsux-av ' + a.v + '">' + cap(a.v) + "</span><span>" + esc(a.t) + "</span></li>"; }
  function openInspect(id) {
    var x = ISSUE_BY_ID[id]; if (!x) return;
    ensureDrawer();
    var pg = PAGE_FOR[id], acts = ACTIONS[id];
    var sugg = (acts && acts.length) ? '<ul class="gsux-acts">' + acts.map(chip).join("") + "</ul>" : '<div class="gsux-fix">' + esc(x.fix || "") + "</div>";
    var openRow = pg
      ? '<button type="button" class="gsux-open" data-path="' + esc(pg) + '"><i class="bi bi-box-arrow-up-right"></i> Open ' + esc(pg) + "</button>"
      : '<div class="gsux-fix">Open the affected page, then click the UX Doctor bookmark.</div>';
    drawerEl.innerHTML =
      '<div class="gsux-h"><div><div class="gsux-lbl">'+TR('uxaudi.g.inspect')+'</div><div class="gsux-title">' + esc(x.title) + "</div>" +
        (pg ? '<div class="gsux-pg"><i class="bi bi-file-earmark-text"></i> ' + esc(pg) + " &middot; worst affected</div>" : "") +
      '</div><button type="button" class="gsux-x" aria-label="'+TT('uxa.at.close')+'">&times;</button></div>' +
      '<div><div class="gsux-slbl">'+TT('uxa.js.suggested_fixes')+'</div>' + sugg + "</div>" +
      '<div class="gsux-hand"><div class="gsux-slbl">'+TT('uxa.js.see_it_on_the_page')+'</div>' +
        '<p class="gsux-p">UX Doctor draws contrast, tap-target and label issues over the real elements. Open the page, then click the bookmark on it.</p>' +
        openRow +
        '<a class="gsux-bmk-link" href="/ux-doctor" target="_blank" rel="noopener">First time? Get the UX Doctor bookmark \u2192</a>' +
      "</div>" +
      (pg ? '<a class="gsux-report" href="/ux-doctor?page=' + encodeURIComponent(pg) + '"><i class="bi bi-graph-up"></i> Behavioural heatmap report <span class="gsux-need">&middot; needs Heatmaps</span></a>' : "");
    drawerEl.querySelector(".gsux-x").addEventListener("click", closeInspect);
    var ob = drawerEl.querySelector(".gsux-open");
    if (ob) ob.addEventListener("click", function () { window.open(pageURL(ob.getAttribute("data-path")), "_blank", "noopener"); });
    backdropEl.classList.add("open"); drawerEl.classList.add("open");
  }

  /* ---- linked UX Experiments (combi panel inside each finding) ----
   * Joins by issue_id to /plugin/ux-experiments/generate. Fully decoupled: if the Experiments
   * plugin is off or not granted, the fetch yields no experiments and the slots stay hidden. */
  var XP = null, XP_KEY = "";
  var XP_LABEL = { proposed: TR('uxaudi.g.proposed'), planned: TR('uxaudi.g.planned'), running: TR('uxaudi.g.running'), done: TR('uxaudi.g.done'), dismissed: "Dismissed" };
  function fetchXP() {
    var key = RANGE.from + "|" + RANGE.to;
    if (XP && XP_KEY === key) return Promise.resolve(XP);
    XP_KEY = key;
    return GS.api("/plugin/ux-experiments/generate?" + siteParam() + "&from=" + RANGE.from + "&to=" + RANGE.to)
      .then(function (r) {
        var d = (r && r.ok && r.data) || {};
        var m = {};
        if (Array.isArray(d.experiments)) d.experiments.forEach(function (e) {
          if (e && e.issue_id) m[e.issue_id] = { title: e.title || e.issue_title || "", status: e.status || "proposed", exp_key: e.exp_key || "" };
        });
        XP = m; return m;
      })
      .catch(function () { XP = {}; return {}; });
  }
  function linkExperiments(host) {
    if (!host) return;
    var slots = host.querySelectorAll("[data-ux-xp]");
    if (!slots.length) return;
    fetchXP().then(function (m) {
      Array.prototype.forEach.call(slots, function (slot) {
        var e = m[slot.getAttribute("data-ux-xp")];
        if (!e) return;
        var st = XP_LABEL[e.status] ? e.status : "proposed";
        var href = "/ux-experiments" + (e.exp_key ? "?exp=" + encodeURIComponent(e.exp_key) : "");
        slot.innerHTML =
          '<a class="ux-xp-row" href="' + href + '" title="'+TT('uxa.tip_uxexp')+'">' +
            '<span class="ux-xp-tag">'+TR('uxaudi.g.test')+'</span>' +
            '<span class="ux-xp-title">' + esc(e.title) + "</span>" +
            '<span class="ux-xps ' + st + '">' + XP_LABEL[st] + "</span></a>";
        slot.hidden = false;
      });
    });
  }

  /* ---- audience audit ---- */
  function loadAudit() {
    GS.api("/plugin/ux-auditor/audit?" + siteParam() + "&from=" + RANGE.from + "&to=" + RANGE.to).then(function (r) {
      var d = (r && r.ok && r.data) || {};
      var g = q("grade");
      g.textContent = d.grade || "—"; g.className = "ux-grade " + gradeCls(d.grade);
      q("hval").innerHTML = (d.health != null ? d.health : "—") + '<span class="ux-100">/100</span>';
      var gd = d.grade_distribution || {};
      q("dist").innerHTML = ["A", "B", "C", "D", "F"].map(function (k) { return '<span class="ux-dpill">' + k + " <b>" + num(gd[k] || 0) + "</b></span>"; }).join("");
      var iss = q("issues"), str = q("strengths");
      if (!d.visitors) { iss.innerHTML = '<div class="ux-empty">' + esc(d.note || TR('uxaudi.f2.no_visitors_to_audit_in_this_range')) + "</div>"; str.innerHTML = ""; renderPages([]); return; }
      ISSUE_BY_ID = {}; (d.issues || []).forEach(function (x) { if (x.id) ISSUE_BY_ID[x.id] = x; });
      PAGE_FOR = {}; (d.pages || []).forEach(function (p) { (p.issue_ids || []).forEach(function (id) { if (!(id in PAGE_FOR)) PAGE_FOR[id] = p.url; }); });
      iss.innerHTML = (d.issues || []).length ? d.issues.map(issueCard).join("") : '<div class="ux-empty">No UX issues detected — clean.</div>';
      linkExperiments(iss);
      str.innerHTML = (d.strengths || []).length ? d.strengths.map(strCard).join("") : '<div class="ux-empty">'+TR('uxaudi.f2.no_standout_strengths_yet')+'</div>';
      renderPages(d.pages || []);
    });
  }
  function renderPages(pages) {
    var pg = q("pages"); if (!pg) return;
    if (!pages.length) { pg.innerHTML = '<div class="ux-empty">'+TR('uxaudi.f2.no_pages_to_rank_in_this_range_yet')+'</div>'; return; }
    if (window.GSMore) { window.GSMore.mount({ container: pg, listClass: "ux-pagelist", items: pages, pageSize: 15, render: pageRow }); }
    else { pg.innerHTML = '<div class="ux-pagelist">' + pages.map(pageRow).join("") + "</div>"; }
    /* audit.js already read ?id= for a visitor; ?page= was ignored. The note goes above the list
       rather than inside it, because GSMore replaces the list's innerHTML when you page through. */
    if (window.GS && GS.applyPageDeepLink) GS.applyPageDeepLink(pg.parentNode || pg, {
      within: pg,
      missText: 'No audited sessions for ' + GS.dlParam("page") + ' in this range.'
    });
  }
  function pageRow(p) {
    var g = String(p.grade || "F").toUpperCase();
    return '<div class="ux-prow" data-gs-page="' + esc(p.url) + '">' +
      '<span class="ux-pgrade g-' + esc(g) + '">' + esc(g) + "</span>" +
      '<span class="ux-purl" title="' + esc(p.url) + '">' + esc(p.url) + "</span>" +
      '<span class="ux-pissue">' + (p.top_issue ? esc(p.top_issue) : '<span class="ux-pnone">'+TT('uxa.js.no_blocking_issue')+'</span>') + "</span>" +
      '<span class="ux-pscore">' + (p.score != null ? p.score : "\u2014") + '<span class="ux-pu">/100</span></span>' +
      '<span class="ux-psess">' + num(p.sessions) + " sess</span></div>";
  }
  function issueCard(x) {
    var acts = ACTIONS[x.id];
    var body = (acts && acts.length)
      ? '<div class="ux-fixes"><div class="ux-fixes-h"><span class="rec">'+TT('uxa.js.do_this')+'</span>' + inspectLink(x) + "</div>" +
          '<ul class="ux-acts">' + acts.map(function (a) { return '<li class="ux-act"><span class="ux-av ' + a.v + '">' + cap(a.v) + "</span><span>" + esc(a.t) + "</span></li>"; }).join("") + "</ul></div>"
      : '<div class="ux-fix"><span class="rec">Fix</span><span>' + esc(x.fix) + "</span>" + inspectLink(x) + "</div>";
    return '<div class="ux-find ' + esc(x.severity) + '">' +
      '<div class="ux-find-top"><span class="ux-find-title">' + esc(x.title) + "</span>" +
      '<span class="ux-sev ' + esc(x.severity) + '">' + esc(x.severity) + "</span>" +
      (x.affected != null ? '<span class="ux-affected">' + num(x.affected) + " visitors &middot; " + (x.share || 0) + "%</span>" : "") +
      "</div>" +
      '<div class="ux-find-detail">' + esc(x.detail) + "</div>" +
      body +
      (x.id ? '<div class="ux-xp" data-ux-xp="' + esc(x.id) + '" hidden></div>' : "") + "</div>";
  }
  function strCard(x) {
    return '<div class="ux-str"><i class="bi bi-check-circle-fill ic"></i><div><div class="t">' + esc(x.title) + '</div><div class="d">' + esc(x.detail || "") + "</div></div>" +
      (x.share != null ? '<span class="sh">' + (x.share || 0) + "%</span>" : "") + "</div>";
  }

  /* ---- one visitor ---- */
  function loadVisitor(vid) {
    if (!vid) return;
    var host = q("visitor");
    host.innerHTML = '<div class="ux-empty">Loading&hellip;</div>';
    GS.api("/plugin/ux-auditor/get?" + siteParam() + "&id=" + encodeURIComponent(vid)).then(function (r) {
      var d = (r && r.ok && r.data) || {};
      if (!d.summary) { host.innerHTML = '<div class="ux-empty">' + esc(d.note || TR('uxaudi.f2.no_audit_for_this_visitor_yet')) + "</div>"; return; }
      var ft = d.features || {};
      var gcls = (d.grade === "A" || d.grade === "B") ? "g-A" : (d.grade === "C" ? "g-C" : "g-F");
      host.innerHTML =
        '<div class="ux-vsum">' + esc(d.summary) + '<span class="ux-grade ' + gcls + ' ux-vgrade">' + esc(d.grade) + "</span></div>" +
        '<div class="ux-vmeta">'+TR('uxaudi.g.ux_score')+'<b>' + (d.score || 0) + "</b> &middot; frustration <b>" + (ft.frustration || 0) + "</b> &middot; attention <b>" + (ft.attention || 0) + "</b> &middot; scroll <b>" + (ft.scroll || 0) + "%</b> &middot; clicks <b>" + (ft.clicks || 0) + "</b></div>" +
        '<div class="ux-findings">' + (d.issues || []).map(issueCard).join("") + "</div>" +
        ((d.strengths || []).length ? '<div class="ux-strengths" style="margin-top:10px">' + d.strengths.map(strCard).join("") + "</div>" : "") +
        (!(d.issues || []).length && !(d.strengths || []).length ? '<div class="ux-empty">'+TR('uxaudi.f2.no_notable_issues_or_strengths')+'</div>' : "");
      (d.issues || []).forEach(function (x) { if (x.id && !(x.id in ISSUE_BY_ID)) ISSUE_BY_ID[x.id] = x; });
      linkExperiments(host);
    });
  }

  ready(function () {
    var f = q("from"), t = q("to");
    _rpInit();
    var open = q("load"), vidIn = q("vid");
    if (open && vidIn) open.addEventListener("click", function () { loadVisitor(vidIn.value.trim()); });
    if (vidIn) vidIn.addEventListener("keydown", function (e) { if (e.key === TR('uxaudi.g.enter')) loadVisitor(vidIn.value.trim()); });
    root.addEventListener("click", function (e) {
      var b = e.target.closest ? e.target.closest("[data-ux-inspect]") : null;
      if (b) { e.preventDefault(); openInspect(b.getAttribute("data-ux-inspect")); }
    });
    loadAudit();
    var id = new URLSearchParams(location.search).get("id");
    if (id) { if (vidIn) vidIn.value = id; loadVisitor(id); }
  });
})();
